// Libraries
import { Flex, Text } from '@chakra-ui/react';
import { ReactElement } from 'react';
// Utils
import text from '@translations/en.json';
// Types
import { VerticalFieldProps } from './VerticalField.type';

/**
 * A vertical field component that displays a label above a value with an optional unit of measurement.
 *
 * @component
 * @param {VerticalFieldProps} props - The props for the VerticalField component.
 * @param {string} props.label - The label to be displayed above the value.
 * @param {string|number} props.value - The value to be displayed.
 * @param {string} [props.unit] - The unit of measurement (optional) to be displayed after the value.
 * @returns {ReactElement} The VerticalField component.
 */
export const VerticalField = ({ label, value, unit }: VerticalFieldProps): ReactElement => {
  const whiteSpace = unit ? 'nowrap' : 'normal';
  const valueToShow = value ?? text.na;

  return (
    <Flex direction='column'>
      <Text fontSize='xs' color='grey.100' whiteSpace='nowrap'>
        {label}
      </Text>
      <Text fontSize='s' color='text.dark'>
        {valueToShow}
        {unit && (
          <Text as='span' fontSize='xs' color='grey.100' whiteSpace={whiteSpace}>
            {` ${unit}`}
          </Text>
        )}
      </Text>
    </Flex>
  );
};
